//
//
//
//
//
//
//
//
//
//
//

import TeacherDialog from './TeacherDialog';

export default {
  name: 'Feedback',
  components: { TeacherDialog },
  props: { feedbackListData: { type: Array, default: () => [] } },
  data() {
    return {
      feedbackList: this.feedbackListData,
      carouselItems: [],
      isTeacherDialogShow: false,
      currentId: 0,
    };
  },
  methods: {
    getLecturerCarouselList() {
      this.$api('getLecturerCarouselList', { size: 5 }).then(data => {
        this.carouselItems = data;
      });
    },
    openTeacherCard(id) {
      this.currentId = id;
      this.isTeacherDialogShow = true;
    },
  },
  mounted() {
    this.getLecturerCarouselList();
  },
};
